import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
const Navbar = ({ style }) => {
  const { t, i18n } = useTranslation();
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lng;
  };
  const handleLanguageChange = (lng) => {
    changeLanguage(lng);
    closeLanguageMenu();
  };
  const closeLanguageMenu = () => {
    setIsLanguageMenuOpen(false);
  };
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (window.scrollY > 50) {
        navbar.classList.add("scrolled");
        navbar.classList.add("sticky-top");
      } else {
        navbar.classList.remove("scrolled");
        navbar.classList.remove("sticky-top");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark px-4 px-lg-5 py-3 py-lg-0"
      style={{ ...style }}
    >
      <div style={{ display: "flex" }}>
        <a href="/" className="navbar-brand p-0">
          <img
            className="img-fluid"
            style={{ paddingInlineEnd: "10px" }}
            src="/images/logos/main-logo.webp"
            alt={t("navbar_logo_alt")}
          />
          <h5 className="m-0 fw-bold text-secondary" style={{paddingTop:'10px'}}>{t("company-name")}</h5>
        </a>
      </div>
      <div className="language-e" style={{ display: "none" }}>
        <div className="mobile-controls">
          <button
            className="mobile-language-toggle"
            onClick={toggleLanguageMenu}
            aria-label="Change language"
          >
            <FontAwesomeIcon icon={faGlobe} />
          </button>
          {isLanguageMenuOpen && (
            <div className="mobile-language-dropdown">
              <button
                className={`mobile-lang-item ${
                  i18n.language === "en" ? "active" : ""
                }`}
                onClick={() => handleLanguageChange("en")}
              >
                English
              </button>
              <button
                className={`mobile-lang-item ${
                  i18n.language === "ar" ? "active" : ""
                }`}
                onClick={() => handleLanguageChange("ar")}
              >
                العربية
              </button>
            </div>
          )}
        </div>
              <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>
      </div>


      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav py-0 pe-4">
          <a href="/" className="nav-item nav-link active">
            {t("home")}
          </a>
          <a href="/#about" className="nav-item nav-link">
            {t("about-us")}
          </a>
          <a href="/#products" className="nav-item nav-link">
            {t("products-menu")}
          </a>
          <a href="/#contact" className="nav-item nav-link">
            {t("contact-us")}
          </a>
        </div>
      </div>
      <div className="nav-e" style={{ display: "flex" }}>
        <div className="d-flex align-items-center gap-3">
          <LanguageSwitcher />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
